import React from 'react'
import {
  PricingTabHeaderIconWrapper,
  PricingTabHeaderStyled,
  PricingTabHeaderText,
} from 'Features/pricing/components/PricingTabHeader/PricingTabHeader.styled'

type PricingTabHeaderProps = {
  text: string
  icon?: React.ReactNode
  isPm?: boolean
}

export const PricingTabHeader = ({ icon, text, isPm }: PricingTabHeaderProps) => {
  return (
    <PricingTabHeaderStyled>
      {icon && <PricingTabHeaderIconWrapper isPm={isPm}>{icon}</PricingTabHeaderIconWrapper>}
      <PricingTabHeaderText>{text}</PricingTabHeaderText>
    </PricingTabHeaderStyled>
  )
}
